<script>
  import { onDestroy } from 'svelte';

  let { item } = $props();

  const mediaQuery = window.matchMedia('(max-width: 767px)');
  const handleMediaChange = event => isMobile = event.matches;

  let isMobile = $state(mediaQuery.matches);

  mediaQuery.addEventListener('change', handleMediaChange);
  onDestroy(() => mediaQuery.removeEventListener('change', handleMediaChange));
</script>

<div class="IN1_cart__item">
  <div class="IN1_cart__item-name smaller">
    <span class="bolder-m">{item.name}</span> 
    {#if item.type == 'Appointment'}
      - <strong>{item.panacea_data?.outline}</strong>
    {:else}
      <span class="IN1_cart__item-quantity--desktop"> - { parseFloat(item.quantity).toFixed() } szt.</span>
    {/if}
  </div>
  
  <div class="IN1_cart__item-quantity">
    <span class="IN1_cart__item-quantity--mobile">
      { parseFloat(item.quantity).toFixed() }
      {#if item.quantity > 1}
        x {item.price_with_currency} /
      {/if}
      szt.
    </span>
    {#if item.quantity > 1}
      <span class="IN1_cart__item-price-single">{item.price_with_currency} / szt.</span>
    {/if}    
  </div>

  <div class="IN1_cart__item-price">
    {item.total_price_with_currency}
  </div>
</div>


<style>
  .IN1_cart__item {
    border-bottom: 1px solid #e0e0e0;
    display: grid;
    grid-template-areas:
      "name quantity price";
    grid-template-columns:auto max-content max-content;
    width: 100%;
    grid-column-gap: 30px;
    grid-row-gap: 0;
    padding: 10px 0;
  }

  .IN1_cart__item:first-of-type {
    padding-top: 5px;
  }

  .IN1_cart__item:last-of-type {
    border-bottom: 0;
    padding-bottom: 0;
  }

  .IN1_cart__item-name {
    grid-area: name;
    align-self: end;
  }

  .IN1_cart__item-quantity {
    grid-area: quantity;
  }

  .IN1_cart__item-quantity--mobile {
      display: none;
    }

    .IN1_cart__item-quantity--desktop {
      display: inline;
    }

  .IN1_cart__item-price {
    grid-area: price;
    align-self: end;
    text-align: right;
  }

  .IN1_cart__item-price-single {
    font-size: 0.9em;
    margin-left: 10px;
  }

  @media (max-width: 767px) {
    .IN1_cart__item {
      grid-template-columns: auto auto;
      grid-template-areas:
        "name name"
        "quantity price";
      grid-column-gap: 15px;
    }

    .IN1_cart__item-name {
      line-height: 1.1em;
    }

    .IN1_cart__item-price {
      line-height: 1.1em;
      align-self: center;
    }

    .IN1_cart__item-quantity--mobile {
      display: inline;
    }

    .IN1_cart__item-quantity--desktop {
      display: none;
    }

    .IN1_cart__item-price-single {
      display: none;
    }
  }
</style>
